import classNames from "classnames";
import { startCase } from "lodash";
import { Component } from "react";
import { LocationConfidenceScoresLabelEnum } from "@app/projects/enumerators";
import { FeatureFlagContextProps, withFeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import { DropdownItem } from "@app/shared/checkbox-dropdown/types";
import MultiselectDropdown from "@app/shared/checkbox-dropdown/MultiselectDropdown";

type AccuracyPractitionerAtLocationConfidenceFilterProps = FeatureFlagContextProps & {
  onPracAtLocConfidenceChange: (confidenceScore: number) => void;
  onPracAtLocConfidenceChangeDropdown: (selections: DropdownItem<number>[]) => void;
  practitionerAtLocationConfidenceIds: number[];
}

class WrappedAccuracyPractitionerAtLocationConfidenceFilter extends Component<AccuracyPractitionerAtLocationConfidenceFilterProps> {
  public render() {
    return (
      <>
        <p className="lead mb0 demibold">Practitioner At Location Confidence Filter</p>
        <p className="mb-1">Please select the Confidence values to include:</p>
        {this.renderAccuracyPractitionerAtLocationConfidenceFilter()}
      </>
    );
  }

  private renderAccuracyPractitionerAtLocationConfidenceFilter() {
    const practitionerAtLocationConfidenceItems: DropdownItem<number>[] = [];
    const selectedItems: DropdownItem<number>[] = [];
    let selectText = "";
    Object.values(LocationConfidenceScoresLabelEnum).forEach((v, i) => {
      const item = {
        key: i,
        name: startCase(v),
      };
      practitionerAtLocationConfidenceItems.push(item)
      if (this.props.practitionerAtLocationConfidenceIds.indexOf(i) > -1) {
        selectedItems.push(item);
      }
    });
    selectText = `${selectedItems.length} of ${practitionerAtLocationConfidenceItems.length} options selected`;

    return (
      <div className="form-group row" >
        <label className="col-12 col-form-label ptb0 text-start">Include</label>
        <div className={classNames("col-12 col-xl-10 col-lg-9 mt0")}>
        <MultiselectDropdown
          label="Practitioner At Location Confidence Filter"
          hideLabel={true}
          containerClassName="w-100"
          customSelectInputText={selectText}
          items={practitionerAtLocationConfidenceItems}
          selectedItems={selectedItems}
          testId="accuracy-practitioner-at-location-confidence-filter__dropdown"
          onSelectionChanged={(selections) => this.props.onPracAtLocConfidenceChangeDropdown(selections)}
        />
        </div>
      </div>
    );
  }
}

const AccuracyPractitionerAtLocationConfidenceFilter = withFeatureFlagContext(WrappedAccuracyPractitionerAtLocationConfidenceFilter);
export default AccuracyPractitionerAtLocationConfidenceFilter;
